import {gql} from 'apollo-angular';
import {ImageFragment} from "./fragments/Image";

export const GET_ROOKIE_OFFER_BY_CODE = gql`
  query GetRookieOfferByCode($districtId: Int!, $timeSlotId: Int!, $shortCode: String!) {
    rookieOfferByCode(districtId: $districtId, timeSlotId: $timeSlotId, shortCode: $shortCode) {
      id
    }
  }
`;
